import React from 'react';
import styled from 'styled-components';

const Line = styled.div`
  height: 1px;
  width: 100%;
  margin: 8px 0;
  background: #d7dde5;
`;

const Separator = (): JSX.Element => <Line />;

export default Separator;
